import classNames from 'classnames';

interface SimpleCardProps {
  title: string;
  image?: string | null;
  isActive?: boolean;
  isBoled?: boolean;
  guid?: string;
  clickHandler?: () => void;
  customClass?: string;
}
const CardInputGroup = ({
  isActive,
  isBoled,
  title,
  image,
  customClass,
  clickHandler,
}: SimpleCardProps) => {
  return (
    <div
      className={classNames(
        'flex my-1 pb-2 rounded-[10px] w-[76px] shadow-xs h-[90px] text-md  flex-col items-center justify-center border-2 border-[#EAECF0]',
        customClass,
        {
          '!bg-farm-shop-50': isBoled,
          ' !border-farm-shop-400  bg-lime-50': isActive,
          'border-[#EAECF0] bg-white': !isActive,
        },
      )}
      onClick={clickHandler}
    >
      <div className="flex flex-col items-center justify-center flex-1 gap-0.5 ">
        <div className="flex  h-[80%] px-2 pt-2">
          <img
            src={image || ''}
            alt={title}
            className="object-contain h-full"
          />
        </div>
        <span className="text-xs flex-1 h-[20%] font-Medium ">{title}</span>
      </div>
    </div>
  );
};

export default CardInputGroup;
